import { Link, useLoaderData } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { TeamCard } from "../../components/teams/TeamCard";
import type { TeamListData } from "../../routes/loaders";
import type { Role } from "../../types/user";
import styles from "./TeamListPage.module.css";

export default function TeamListPage() {
  const { teams, organizationId } = useLoaderData() as TeamListData;
  const { user } = useAuth();

  const userRole: Role | undefined = user?.organizations.find(
    (org) => org.id === organizationId,
  )?.role;

  const canManageTeams = userRole === "owner" || userRole === "admin";

  return (
    <div className="container">
      <div className={styles.pageHeader}>
        <div>
          <h1>Teams</h1>
          <Link to={`/organizations/${organizationId}`} className={styles.backLink}>
            ← Back to Organization
          </Link>
        </div>
        {canManageTeams && (
          <Link
            to={`/organizations/${organizationId}/teams/create`}
            className="button button-primary"
          >
            Create Team
          </Link>
        )}
      </div>

      {teams.length === 0 ? (
        <div className={styles.emptyState}>
          <p>No teams yet</p>
          {canManageTeams && (
            <Link
              to={`/organizations/${organizationId}/teams/create`}
              className="button button-primary"
            >
              Create Your First Team
            </Link>
          )}
        </div>
      ) : (
        <div className={styles.teamGrid}>
          {teams.map((team) => (
            <TeamCard key={team.id} team={team} organizationId={organizationId} />
          ))}
        </div>
      )}
    </div>
  );
}
